import React from 'react';
import { pick, prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { getURLParam } from '@theme/js/utils/url.util';
import { WebContent } from '@core/js/components/system/WebContent';
import { DefaultHeader } from '@theme/js/components/main/DefaultHeader';
import { componentService } from '@core/js/services/component.service';
import { useDeviceSelector, usePageSelector, useAppSelector } from '@core/js/store/hooks';

export const Header = () => {
    const location = useLocation();
    const isMobile = useDeviceSelector(prop('isMobile')); /* Lugano changes */
    const headerWCID = useAppSelector(prop('headerWCID'));
    const { headerWcId, overrideHeader } = usePageSelector(pick(['headerWcId', 'overrideHeader']));
    const hideHeaderByUrl = getURLParam(location.search, 'hideHeader') === '1';
    const hideDesktopHeaderByUrl = getURLParam(location.search, 'showHeaderOnlyOnMobile') === '1';

    if (hideHeaderByUrl) {
        return null;
    }

    if (hideDesktopHeaderByUrl && !isMobile) {
        return null;
    }

    if (overrideHeader && !headerWcId) {
        return null;
    }

    if (overrideHeader && headerWcId) {
        return <WebContent id={headerWcId} />;
    }

    if (headerWCID) {
        return <WebContent id={headerWCID}/>;
    }

    return <DefaultHeader />;
};

componentService.registerWebContentComponents({ Header });
